import { isMobile } from "@rio-cloud/rio-uikit/utils/deviceUtils";

const fixedColumnsValues = [
  "criticidade",
  "veiculo",
  "chassi",
  "odometro",
  "horimetro",
  "fixedTempo",
];
const fixedColumnsMobileValues = ["veiculo"];

const scrollableColumnsValues = [
  "chamado",
  "triagem",
  "deslocamento",
  "remocao",
  "diagnose2nivel",
  "diagnose3nivel",
  "diagnose4nivel",
  "analiseGarantia",
  "okCliente",
  "pecas",
  "pecasTransito",
  "aguardandoReparo",
  "reparo",
  "liberacao",
];
const scrollableColumnsMobileValues = [
  "criticidade",
  "chassi",
  "odometro",
  "horimetro",
  "tempo",
  "chamado",
  "triagem",
  "deslocamento",
  "remocao",
  "diagnose2nivel",
  "diagnose3nivel",
  "diagnose4nivel",
  "analiseGarantia",
  "okCliente",
  "pecas",
  "pecasTransito",
  "aguardandoReparo",
  "reparo",
  "liberacao",
];

const allColumns = [
  {
    value: "criticidade",
    label: "Criticidade",
    details: { width: 120, defaultWidth: 120, maxWidth: 350 },
  },
  {
    value: "veiculo",
    label: "Veículo",
    details: { width: 100, defaultWidth: 100, maxWidth: 350 },
  },
  {
    value: "chassi",
    label: "Chassi",
    details: { width: 150, defaultWidth: 150, maxWidth: 350 },
  },
  {
    value: "odometro",
    label: "Odômetro",
    details: { width: 120, defaultWidth: 120, maxWidth: 350 },
  },
  {
    value: "horimetro",
    label: "Horímetro",
    details: { width: 120, defaultWidth: 120, maxWidth: 350 },
  },
  {
    value: "fixedTempo",
    label: "Tempo corrido total",
    details: { width: 150, defaultWidth: 250, maxWidth: 250 },
  },
  {
    value: "chamado",
    label: "Chamado",
    details: { width: 120, defaultWidth: 120, maxWidth: 150 },
  },
  {
    value: "triagem",
    label: "Triagem",
    details: { width: 160, defaultWidth: 160, maxWidth: 160 },
  },
  {
    value: "deslocamento",
    label: "Deslocamento",
    details: { width: 100, defaultWidth: 100, maxWidth: 130 },
  },
  {
    value: "remocao",
    label: "Remoção",
    details: { width: 100, defaultWidth: 100, maxWidth: 150 },
  },
  {
    value: "diagnose2nivel",
    label: "Diagnose 2º Nível",
    details: { width: 100, defaultWidth: 100, maxWidth: 100 },
  },
  {
    value: "diagnose3nivel",
    label: "Diagnose 3º Nível",
    details: { width: 100, defaultWidth: 100, maxWidth: 100 },
  },
  {
    value: "diagnose4nivel",
    label: "Diagnose 4º Nível",
    details: { width: 100, defaultWidth: 100, maxWidth: 120 },
  },
  {
    value: "analiseGarantia",
    label: "Análise de Garantia",
    details: { width: 100, defaultWidth: 100, maxWidth: 160 },
  },
  {
    value: "okCliente",
    label: "Ok do Cliente",
    details: { width: 100, defaultWidth: 100, maxWidth: 200 },
  },
  {
    value: "pecas",
    label: "Peças",
    details: { width: 100, defaultWidth: 100, maxWidth: 200 },
  },
  {
    value: "pecasTransito",
    label: "Peças em Trânsito",
    details: { width: 100, defaultWidth: 100, maxWidth: 200 },
  },
  {
    value: "aguardandoReparo",
    label: "Aguardando Reparo",
    details: { width: 100, defaultWidth: 100, maxWidth: 200 },
  },
  {
    value: "reparo",
    label: "Reparo",
    details: { width: 100, defaultWidth: 100, maxWidth: 200 },
  },
  {
    value: "liberacao",
    label: "Liberação",
    details: { width: 100, defaultWidth: 100, maxWidth: 200 },
  },
];

export const fixedColumns = allColumns.filter((column) => {
  if (isMobile()) return fixedColumnsMobileValues.includes(column.value);
  return fixedColumnsValues.includes(column.value);
});

export const scrollableColumns = allColumns.filter((column) => {
  if (isMobile()) return scrollableColumnsMobileValues.includes(column.value);
  return scrollableColumnsValues.includes(column.value);
});
